module.exports = __webpack_public_path__ + "static/process-9ad0f2438d6e44275467680491f5ad9a.png";